import React from "react";
import { useGetAllMusicStatsForLocation } from "./hooks/useGetAllMusicStatsForLocation";
import { useGetDownloadMusicStatisticsForLocation } from "./hooks/useGetDownloadMusicStatisticsForLocation";
import { MusicStatsView } from "./MusicStatsView";
import routeNames from "../../constants/routeNames";
import { useHistory } from "react-router-dom";
import i18n from "../../constants/i18n";

interface MusicStatsContainerProps {
    locationId: number;
}

export function LocationMusicStatsContainer(props: MusicStatsContainerProps) {
    const history = useHistory();

    const musicStats = useGetAllMusicStatsForLocation(props.locationId);
    const isLoading = musicStats && musicStats.isLoading;
    const data = musicStats && musicStats.data;
    const musicStatsDownload = useGetDownloadMusicStatisticsForLocation(
        props.locationId
    );

    const locationId = props.locationId;

    const backToOverview = () => {
        history.push(
            `${routeNames.locationDetails}/`.replace(
                ":crematoryID",
                String(props.locationId)
            )
        );
    };

    return (
        <MusicStatsView
            isLoading={isLoading}
            data={data}
            musicStatsDownload={musicStatsDownload}
            locationId={locationId}
            onBackToOverviewClick={backToOverview}
            title={i18n.generic.LocationMusicTop10}
        />
    );
}
